import ImagePlaceholder from "@/components/base/ImagePlaceholder";

export default function Marques() {
  const marques = [
    {
      name: "Somfy",
      href: "/moteur-somfy",
      icon: "ri-flashlight-line",
      color: "bg-blue-50 text-blue-600",
      border: "border-blue-200",
      badge: "Pièces d'origine",
      badgeColor: "bg-blue-100 text-blue-700",
      desc: "Motorisation & automatisme",
      image:
        "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/e16d334ad0dcb90d8cdd235eb2be11a7.jpeg",
      imageAlt: "Réparation moteur Somfy de volet roulant à Strasbourg",
      imageWidth: 300,
      imageHeight: 120,
    },
    {
      name: "Nice",
      href: "/moteur-nice",
      icon: "ri-remote-control-line",
      color: "bg-orange-50 text-orange-600",
      border: "border-orange-200",
      badge: "Pièces d'origine",
      badgeColor: "bg-orange-100 text-orange-700",
      desc: "Motorisation & commandes",
      image:
        "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/adb07df6ce722f4ed8f7f8186a524891.jpeg",
      imageAlt: "Réparation moteur Nice de volet roulant à Strasbourg",
      imageWidth: 300,
      imageHeight: 120,
    },
    {
      name: "Simu",
      href: "/reparation-volet-roulant",
      icon: "ri-wifi-line",
      color: "bg-emerald-50 text-emerald-600",
      border: "border-emerald-200",
      badge: "Certifié",
      badgeColor: "bg-emerald-100 text-emerald-700",
      desc: "Motorisation connectée",
      image:
        "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/b2ea8caedb19d039a2f34a7c1227ad7c.jpeg",
      imageAlt: "Réparation moteur Simu de volet roulant à Strasbourg",
      imageWidth: 300,
      imageHeight: 120,
    },
    {
      name: "Bubendorff",
      href: "/moteur-bubendorff",
      icon: "ri-shield-check-line",
      color: "bg-red-50 text-red-600",
      border: "border-red-200",
      badge: "Pièces d'origine",
      badgeColor: "bg-red-100 text-red-700",
      desc: "Volets roulants sur mesure",
      image:
        "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/d3137d59be0cffa96f7aa072f468a8a7.jpeg",
      imageAlt: "Réparation moteur Bubendorff de volet roulant à Strasbourg",
      imageWidth: 300,
      imageHeight: 120,
    },
    {
      name: "Profalux",
      href: "/moteur-profalux",
      icon: "ri-hammer-line",
      color: "bg-slate-50 text-slate-600",
      border: "border-slate-200",
      badge: "Pièces d'origine",
      badgeColor: "bg-slate-100 text-slate-700",
      desc: "Menuiserie aluminium",
      image:
        "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/2cd46f844316d9867f1ef19be25f2833.jpeg",
      imageAlt: "Réparation moteur Profalux de volet roulant à Strasbourg",
      imageWidth: 300,
      imageHeight: 120,
    },
    {
      name: "Elero",
      href: "/reparation-volet-roulant",
      icon: "ri-sun-line",
      color: "bg-amber-50 text-amber-600",
      border: "border-amber-200",
      badge: "Certifié",
      badgeColor: "bg-amber-100 text-amber-700",
      desc: "Motorisation solaire",
      image:
        "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/17a531dad2cd32db34d4b89221969f3e.jpeg",
      imageAlt: "Réparation moteur Elero de volet roulant à Strasbourg",
      imageWidth: 300,
      imageHeight: 120,
    },
  ];

  return (
    <section className="bg-brand-light py-14 md:py-20 border-y border-brand-border">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <p className="text-brand-cyan text-xs font-medium uppercase tracking-wider mb-2 text-center">
          Toutes marques
        </p>
        <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold text-center mb-3">
          Nous réparons toutes les <strong className="text-brand-blue">marques</strong>
        </h2>
        <p className="text-brand-text text-sm md:text-base text-center max-w-2xl mx-auto mb-8 md:mb-12">
          Interventions certifiées sur <strong className="text-brand-blue">Somfy, Nice, Simu, Bubendorff, Profalux et Elero</strong> — pièces d'origine et expertise technique.
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {marques.map((m) => (
            <a
              key={m.name}
              href={m.href}
              className={`group bg-white border ${m.border} rounded-xl overflow-hidden transition-all block cursor-pointer`}
            >
              {/* Image miniature */}
              <div className="w-full h-24 overflow-hidden bg-[#E8EFF5] relative">
                <ImagePlaceholder
                  src={m.image}
                  alt={m.imageAlt}
                  className="w-full h-full"
                  loading="lazy"
                  width={m.imageWidth}
                  height={m.imageHeight}
                />
                {/* Badge */}
                <span className={`absolute top-2 left-2 inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold ${m.badgeColor}`}>
                  <i className="ri-check-line"></i>
                  {m.badge}
                </span>
              </div>

              {/* Contenu */}
              <div className="p-3 md:p-4 text-center">
                <div
                  className={`w-8 h-8 mx-auto flex items-center justify-center rounded-full ${m.color} mb-2`}
                >
                  <i className={`${m.icon} text-sm`}></i>
                </div>
                <h3 className="text-brand-blue text-sm font-bold mb-0.5">
                  {m.name}
                </h3>
                <p className="text-brand-text text-xs leading-tight">
                  {m.desc}
                </p>
              </div>
            </a>
          ))}
        </div>

        {/* Lien vers page marques */}
        <div className="text-center mt-8 md:mt-10">
          <p className="text-brand-text text-sm">
            Vous avez une autre marque ?{" "}
            <a
              href="/contact"
              className="text-brand-cyan font-semibold hover:text-brand-cyan/80 transition-colors"
            >
              Contactez-nous
            </a>
            {" "}
            — nous intervenons sur 95% des fabricants du marché.
          </p>
        </div>
      </div>
    </section>
  );
}